(function () {
  function currentTheme() {
    return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }

  function reflectButtons(theme) {
    document.querySelectorAll('[data-dark-mode-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
    });
  }

  function apply(theme) {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    reflectButtons(theme);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-dark-mode-toggle]');
    if (!btn) return;
    var next = currentTheme() === 'dark' ? 'light' : 'dark';
    apply(next);
    try {
      localStorage.setItem('sovyer-theme', next);
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) — toggle still works for this page view */
    }
  });

  reflectButtons(currentTheme());
})();
